<mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
  <mat-card-header>
      <mat-card-title>
          <h5 class="mb-0">
            {{ isUpdating ? 'Izmjena projekta' : 'Novi projekt' }}
          </h5>
      </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <form [formGroup]="projectForm" (ngSubmit)="onSubmit()">

      <mat-form-field class="mb-25">
        <mat-label>Naziv programa/projekta</mat-label>
        <input matInput formControlName="name">
      </mat-form-field>

      <mat-form-field class="mb-25">
        <mat-label>Odobreni iznos</mat-label>
        <input matInput formattedNumber  [config]="{ decimals: 2, useThousands: true, maxDigits: 10 }" formControlName="approvedAmount">
      </mat-form-field>

      <button mat-raised-button color="primary" type="submit" [disabled]="projectForm.invalid">
        {{ isUpdating ? 'Ažuriraj projekt' : 'Kreiraj projekt' }}
      </button>
    </form>
  </mat-card-content>
</mat-card>